import React from 'react'
import SVG from 'react-svg-inline'


const Fearless = () =>
  <div>

    <section className="container">
      <div className="col-12-of-12">
      <iframe src="https://player.vimeo.com/video/235339103" width="100%" height="720" frameBorder="0" allowFullScreen></iframe>
      <p><a href="https://vimeo.com/235339103">FEARLESS</a> from <a href="https://vimeo.com/user46244838">Clockbeats</a> on <a href="https://vimeo.com">Vimeo</a>.</p>
      </div>
    </section>
  </div>

export default Fearless



// WEBPACK FOOTER //
// src/javascripts/clients/Fearless.js